import state from './room.state'
import mutations from './room.mutations'
import actions from './room.actions'

export default {
  state,
  mutations,
  actions
}
